function millisToMinutesAndSeconds(millis) {
  const minutes = Math.floor(millis / 60000);
  const seconds = ((millis % 60000) / 1000).toFixed(0);
  return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
}

/**
 * @name LogList
 * @param {SwucState} state
 * @return {string}
 * @constructor
 */
export function LogList(state) {
  if (state.currentGame === undefined) return "";

  const startTime = new Date(state.currentGame.startTime);

  const baseArr = state.currentGame.log.map((log) => {
    const timestamp = new Date(log.timestamp);
    if (log.player === "none") {
      return `<li class="flex flex-row log-item">
                <span class="text-xs italic">${millisToMinutesAndSeconds(log.timeInGame)}</span>
                <span class="text-sm">${log.message}</span>
          </li>`;
    }

    const player = state[log.player];
    return `<li class="flex log-item justify-between ${log.player === "top" ? "flex-row-reverse" : "flex-row "} ${log.player}">
          <img src="/assets/img/p_${player.leader.id}.png" width="32" height="32" class="" alt="${
            log.player + "/" + player.base.name
          }"/>
          <div>
            <span class="text-xs italic">${millisToMinutesAndSeconds(log.timeInGame)}</span>
            <span class="text-sm">${log.message}</span>
          </div>
    </li>`;
  });
  return baseArr.join("");
}

export function GetGameStats(state) {
  if (state.currentGame === undefined) return "";
  const top = state.currentGame.topBase;
  const bottom = state.currentGame.bottomBase;
  let topDmg = 0;
  let bottomDmg = 0;
  let topHeal = 0;
  let bottomHeal = 0;

  state.currentGame.log.map((log) => {
    if (log.player === "none") {
      return;
    }
    if (log.player === "top") {
      if (log.type === "Damage") {
        topDmg += log.amount || 0;
      } else if (log.type === "Heal") {
        topHeal += log.amount || 0;
      }
    } else {
      if (log.type === "Damage") {
        bottomDmg += log.amount || 0;
      } else if (log.type === "Heal") {
        bottomHeal += log.amount || 0;
      }
    }
  });
  const res = `<div>
          <h3 class="font-bold text-2xl">top/${top.base.name}</h3>
          <p><span class="font-bold">Damage done:</span> ${topDmg}</p>
          <p><span class="font-bold">Healing done:</span> ${topHeal}</p>
      </div>
      <div class="mt-2">
          <h3 class="font-bold text-2xl">bottom/${bottom.base.name}</h3>
          <p><span class="font-bold">Damage done:</span> ${bottomDmg}</p>
          <p><span class="font-bold">Healing done:</span> ${bottomHeal}</p>
      </div>`;

  return res;
}
